import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,{attrs:{"fluid":""}},[_c('peeps-alert-animation',{ref:"animationGlobal",attrs:{"message":"Parcel update was Successful!"}}),_c('card-view',{attrs:{"highlight":_vm.highlight},on:{"update":_vm.onUpdate}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }